import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotel-payment-declined',
  templateUrl: './hotel-payment-declined.component.html',
  styleUrls: ['./hotel-payment-declined.component.css']
})
export class HotelPaymentDeclinedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
